module.exports = __webpack_public_path__ + "img/skh1.ea587d6c.jpg";